/**
 * Analytics Service
 * 통계/분석 관련 모든 API 호출을 중앙화
 */

import { apiClient } from './apiClient';

class AnalyticsService {
  /**
   * 월별 통계 조회
   * @param {string} month - 조회할 월 (YYYY-MM 형식)
   * @returns {Promise<object>} 월별 통계 데이터
   */
  async getMonthlyStats(month) {
    return apiClient.get(`/api/stats/${month}`);
  }
}

export const analyticsService = new AnalyticsService();
export default analyticsService;
